import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Cliques por dia',
  aria: 'Gráfico de cliques por dia',
  tooltip: '{{day}} · {{clicks}} cliques · {{signups}} cadastros · {{paying}} pagantes',
  max: 'máximo {{value}}',
  signupLegend: 'Dia com cadastro',
  empty: 'Nenhum clique ou cadastro no período.',
} satisfies TranslationTree;
